module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-03-9324221fbff089adc68a78c4c52570d8.jpg";